import React, { Component } from 'react';
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Pagination,
} from 'react-bootstrap';
import './PaginationTable.css';
import { withTranslation } from 'react-i18next';

class PaginationTable extends Component {
  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);

    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages),
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages),
      });
    }

    this.changePage(nextProps.page + 1);
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages);
  };

  fillArray(length = 1) {
    return Array.from({ length }, (v, k) => k+1);
  }

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages(this.fillArray(6), total);
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, page + 2, total];
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      }
      return this.fillArray(6);
    }
  };

  changePage(page) {
    const activePage = this.props.page + 1;

    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages),
    });

    this.props.onPageChange(page - 1);
  }

  changePageSize(size) {
    this.props.onPageSizeChange(size);
    setTimeout(() => {
      this.changePage(1);
    }, 0);
  }

  render() {
    const { visiblePages } = this.state;
    const { page, pages, data, t } = this.props;
    const activePage = page + 1;
    const totalPages = pages;
    const totalItems = data.length;

    return (
      <div className="pagination-table">

        <Col sm={4} xsHidden={true}>
          <Form inline>
            <FormGroup>
              <ControlLabel>{t('pagination.Show')}</ControlLabel>{' '}
              <FormControl
                name="pageSize"
                componentClass="select"
                value={this.props.pageSize}
                onChange={e => this.changePageSize(Number(e.target.value))}
                bsSize="sm"
              >
                {this.props.pageSizeOptions.map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </FormControl>
              {' '}<ControlLabel> {t('pagination.of')} {totalItems}</ControlLabel>
            </FormGroup>
          </Form>
        </Col>

        <Col sm={8} xs={12} className="text-right">
          {totalPages > 1 && (
            <Pagination>
              <Pagination.First disabled={activePage === 1} onClick={() => this.changePage(1)}/>
              <Pagination.Prev disabled={activePage === 1} onClick={() => this.changePage(activePage - 1)}/>
              {visiblePages.map((page, index, array) => {
                return (
                  (array[index - 1] + 2) < page
                    ?
                    <Pagination.Ellipsis key={index}/>
                    : (
                      <Pagination.Item key={index}
                        active={activePage === page}
                        onClick={this.changePage.bind(null, page)}>
                        {page}
                      </Pagination.Item>
                    )
                );
              })}
              <Pagination.Next disabled={activePage === totalPages} onClick={() => this.changePage(activePage + 1)}/>
              <Pagination.Last disabled={activePage === totalPages} onClick={() => this.changePage(totalPages)}/>
            </Pagination>
          )}
        </Col>

      </div>
    );
  }
}

export default withTranslation()(PaginationTable);
